/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DashboardResponse } from '../../../../models/login';
import { UserSessionHelperExtendedService } from './user-session-helper-extended.service';

@Injectable({
  providedIn: 'root'
})
export class UserSessionHelperService extends UserSessionHelperExtendedService {
  async setStatusValueFromServiceWorker(): Promise<boolean> {
    if (this.loginRememberMeUtils.checkServiceWorkerController()) {
      return await this.loginRememberMeUtils
        .sendMessage({ type: 'GET_STATUS' })
        .then(async (data: any) => {
          if (data?.eamStatus) {
            return true;
          } else {
            return false;
          }
        });
    } else {
      return false;
    }
  }

  async guestStatus(): Promise<void> {
    if (this.loginRememberMeUtils.checkServiceWorkerController()) {
      await this.loginRememberMeUtils.sendMessage({
        type: 'ADD_STATUS',
        eamStatus: 'GUEST'
      });
    }
  }

  async deleteStatusValuesFromServiceWorker(): Promise<void> {
    if (this.loginRememberMeUtils.checkServiceWorkerController()) {
      await this.loginRememberMeUtils.sendMessage({ type: 'DELETE_STATUS' });
    }
  }

  async isTokenAvailable(): Promise<boolean> {
    if (this.loginRememberMeUtils.checkServiceWorkerController()) {
      return await this.loginRememberMeUtils
        .sendMessage({ type: 'GET_TOKEN' })
        .then(async (data: any) => {
          if (data?.tokenAvailable) {
            this.tokenAvailable = await data?.tokenAvailable;
            return this.tokenAvailable;
          } else {
            return false;
          }
        });
    } else {
      return false;
    }
  }

  async setTokenDetails(): Promise<void> {
    if (this.loginRememberMeUtils.checkServiceWorkerController()) {
      await this.loginRememberMeUtils
        .sendMessage({ type: 'GET_TOKEN' })
        .then(async (data: any) => {
          if (data?.expiresIn && data?.issueTime) {
            this.tokenExpiry = await data?.expiresIn;
            this.tokenIssuedTime = await data?.issueTime;
          }
        });
    }
  }

  async deleteValuesFromServiceWorker(): Promise<void> {
    if (this.loginRememberMeUtils.checkServiceWorkerController()) {
      await this.loginRememberMeUtils
        .sendMessage({ type: 'DELETE_TOKEN' })
        .then(async (data: any) => {
          if (data) {
            this.tokenAvailable = await data?.tokenAvailable;
            this.tokenExpiry = await data?.expiresIn;
            this.tokenIssuedTime = await data?.issueTime;
            this.tokenValue$.next(false);
          }
        });
    }
  }

  checkServiceWorkerSession(
    tokenAvailable: boolean,
    sessionTimeOut: boolean,
    refreshTokenTime: number
  ): boolean {
    return !!(
      tokenAvailable &&
      !sessionTimeOut &&
      !(this.checkTokenExpiryTime() <= refreshTokenTime)
    );
  }

  checkTokenExpiryTime(): number {
    const tokenValidityTime = this.tokenIssuedTime + this.tokenExpiry * 1000;
    return tokenValidityTime - new Date().getTime();
  }

  getServiceWorkerCheck(): boolean {
    if (
      (this.isServiceWorker() && this.tokenValue$.value) ||
      !this.isServiceWorker()
    ) {
      return true;
    }
    return false;
  }

  isServiceWorker(): boolean {
    if (
      this.loginRememberMeUtils.checkServiceWorkerController() &&
      (this.cookieHelper.getCookieValue('accountType') ||
        this.isServiceWorkerHelper())
    ) {
      return true;
    } else {
      return false;
    }
  }

  isServiceWorkerHelper(): boolean {
    return !!(
      window.localStorage.getItem('uid') &&
      window.localStorage.getItem('encyToken')
    );
  }

  nonLoggedInStateHelper(error?: string): Observable<DashboardResponse> {
    this.guestStatus();
    this.removeSessionValues();
    this.tokenValue$.next(true);
    if (error) {
      this.logging.log(error);
    }
    return of({} as DashboardResponse);
  }
}
